'use client';
import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { SlClose } from "react-icons/sl";
import "../../app/job-board/JobBoard.css";
import "./ModalBox.css";
import contactApi from "@/services/contactApi";
import { toast } from "react-toastify";

const ModalBox = ({
  title,
  text,
  buttonText,
  type,
  showInput = false,
  onSubmit,
  onClose,
  autoShowDelay = 3000,
  isAnyModalOpen = false,
  onModalStateChange,
  noOfTimesToShow = 1,
  showOnEveryRefresh = false,
}) => {
  const titleId = `${type}-modal-title`;

  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAnyModalOpen) return;

    const submitted = localStorage.getItem(`${type}_submitted`);
    if (submitted === "true") return;

    let shownCount = Number(localStorage.getItem(`${type}_shown_count`) || 0);

    if (shownCount >= noOfTimesToShow) return;
    let delay = autoShowDelay;

    const sessionLastShown = sessionStorage.getItem(`${type}_session_last_shown`);

    if (sessionLastShown) {
      const diffMs = Date.now() - Number(sessionLastShown);
      if (diffMs < 60000) {
        delay = (60000 - diffMs) + autoShowDelay;
      }
    }


    const lastTime = localStorage.getItem(`${type}_last_submitted`);
    if (lastTime) {
      const hours = (Date.now() - Number(lastTime)) / (1000 * 60 * 60);
      if (hours < 24) return;
    }

    const timer = setTimeout(() => setShow(true), delay);

    return () => clearTimeout(timer);
  }, [isAnyModalOpen, autoShowDelay, type, noOfTimesToShow, showOnEveryRefresh]);

  useEffect(() => {
    if (!show) return;
    const sessionKey = `${type}_shown_this_session`;
    if (sessionStorage.getItem(sessionKey)) return;
    const shownCount = Number(localStorage.getItem(`${type}_shown_count`) || 0);
    localStorage.setItem(`${type}_shown_count`, shownCount + 1);
    localStorage.setItem(`${type}_last_shown`, Date.now());

    sessionStorage.setItem(sessionKey, "true");

  }, [show, type]);

  useEffect(() => {
    onModalStateChange?.(type, show);
  }, [show, type]);


  const handleClose = () => {
    setShow(false);
    sessionStorage.setItem(`${type}_session_last_shown`, Date.now());
    onClose?.();
  };


  const handleSubmit = async () => {
    if (showInput && (!email || !email.includes("@"))) {
      alert("Please enter a valid email.");
      return;
    }

    try {
      setLoading(true);

      if (onSubmit) {
        await onSubmit(email);
      } else {
        const body = showInput ? { email } : {};
        const res = await contactApi.subscribe(type, body);

        if (!res?.success) {
          toast.error(res?.message || "Something went wrong.");
          return;
        }

        toast.success("Submitted successfully!");
      }

      localStorage.setItem(`${type}_submitted`, "true");
      localStorage.setItem(`${type}_last_submitted`, Date.now());

      setShow(false);
      onClose?.();

    } catch (err) {
      console.error(err);
      toast.error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };


  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="Newsletter_modal"
      aria-labelledby={titleId}
    >

      <button type="button" className="Newsletter_close" onClick={handleClose} aria-label="Close dialog">
        <SlClose />
      </button>

      <div className="Newsletter_container">
        <h2 id={titleId} className="Newsletter_title">{title}</h2>
        <p className="Newsletter_text">{text}</p>

        {showInput && (
          <input
            type="email"
            placeholder="Enter Email ID"
            className="Newsletter_input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        )}

        <button className="Newsletter_btn" onClick={handleSubmit} disabled={loading}>
          {loading ? "Submitting..." : buttonText}
        </button>
      </div>
    </Modal>
  );
};

export default ModalBox;
